import { fetchOperation, fetchSegmentOperation } from '@/api/business/operation'
import { useQuery } from '@tanstack/react-query'

export const operationKeys = {
    all: ['operation'] as const,
    lists: () => [...operationKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...operationKeys.lists(), page, perPage, filters] as const,
    details: () => [...operationKeys.all, 'detail'] as const,
    detail: (params: string) => [...operationKeys.details(), params] as const,
}

export const useOperationQuery = () => {
    return useQuery({
        queryFn: fetchOperation,
        queryKey: operationKeys.lists(),
    })
}


export const operationSegmentKeys = {
    all: ['operationsegment'] as const,
    lists: () => [...operationSegmentKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...operationSegmentKeys.lists(), page, perPage, filters] as const,
    details: () => [...operationSegmentKeys.all, 'detail'] as const,
    detail: (params: string) => [...operationSegmentKeys.details(), params] as const,
}

export const useOperationSegmentQuery = (id: Number) => {
    return useQuery({
        queryFn: () => fetchSegmentOperation(id),
        queryKey: operationSegmentKeys.detail(id.toString()),
    })
}